import { render, staticRenderFns } from "./PatientNricDropdown.vue?vue&type=template&id=11c12810&scoped=true&lang=pug&"
import script from "./PatientNricDropdown.vue?vue&type=script&lang=js&"
export * from "./PatientNricDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PatientNricDropdown.vue?vue&type=style&index=0&id=11c12810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c12810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VIcon,VMenu,VProgressLinear,VSheet,VTextField})
